import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { AutoBet } from './autoBet/index.js';
import '../../core/enums/GameSpecificTypes.js';
import '../../core/enums/MaxPayoutDataTypes.js';
import '../../core/enums/Chat.js';
import '../../core/enums/GameModes.js';
import '../../core/enums/IconTypes.js';
import '../../core/enums/BetStatus.js';
import '../../core/enums/PopupTypes.js';
import '../../core/enums/ApiVersion.js';
import '../../core/enums/RoundStatus.js';
import '../../core/enums/FreeBetsStatus.js';
import '../../core/enums/SocketEvents.js';
import '../../core/enums/TranslationKeys.js';
import '../../core/enums/TimeoutMaxValue.js';
import '../../core/enums/ApiServiceTypes.js';
import '../../core/enums/EnvironmentTypes.js';
import '../../core/enums/DefaultQueryValues.js';
import '../../core/enums/FreeBetWinningType.js';
import '../../core/enums/DefaultQueryParams.js';
import '../../core/enums/BetHistoryFilterTypes.js';
import '../../core/enums/GameThemeTypes.js';
import '../../core/enums/RequestStatus.js';
import '../../core/enums/FetchDefaultPaths.js';
import '../../core/enums/ResponseCodes.js';
import '../../../_tslib-7a01aab4.js';
import { a2 as betDataStore, z as freeBetStore, $ as gameConfigStore, a1 as doBetStore } from '../../../validateBalanceOnBet-af4f4a9b.js';
import '../../core/store/chatStore.js';
import '../../core/store/wageringStore.js';
import '../../core/store/roundInfoStore.js';
import '../../core/store/userCountStore.js';
import '../../core/store/gameResultStore.js';
import '../../core/store/resultHashStore.js';
import '../../core/store/userWinBetsStore.js';
import '../../core/store/notificationStore.js';
import '../../core/store/selectedResultInfoStore.js';
import '../../core/store/forCrashGame/inputValidationStore.js';
import '../../core/store/forCrashGame/totalBetStore.js';
import '../../core/store/forCrashGame/resultReportStore.js';
import { gameStore } from '../../core/store/forCrashGame/gameStore.js';
import '../../core/services/liveConnection/types.js';
import 'axios';
import '../../core/services/sound/types.js';
import '../../core/services/sound/SoundService.js';
import '../../core/services/sound/defaultSounds.js';
import '../../core/services/api/types.js';
import '../../core/services/ApiServices.js';
import '../../../momentFormat-e9197995.js';
import '../../core/polyfill.js';
import { BetAmount } from './betamount/index.js';
import { AutoCashOut } from './autoCashOut/index.js';
import { QuickBetAmountButtons } from './quickBetamountButtons/index.js';
import { DoBetBtnSection } from './betButton/index.js';
import { AutoBetPopUp } from './autoBet/autoBetPopUp/index.js.js';
import '../../contexts/TranslationContext.js';
import '../../contexts/StoreContext.js';
import 'mobx';
import '../../core/classes/httpResponse/index.js';
import '@microsoft/signalr';
import '../../core/enums/BogLineGameConfig.js';
import '../../core/helpers/parseQuery.js';
import '../../core/enums/StatisticsSortingTypes.js';
import '../../core/services/api/BaseApiService.js';
import '../../core/helpers/deepCopy.js';
import '../../../table-line/t_types/enums/BetResponseCode.js';
import '../../../table-line/t_types/enums/BetErrorMessages.js';
import '../../../table-line/t_types/enums/NotificationByResponseCode.js';
import '../../../table-line/t_types/enums/FreeChipTypes.js';
import '../../../table-line/t_types/enums/PopupTypes.js';
import '../../core/helpers/formatDate.js';
import '../../core/helpers/isMobile.js';
import '../../core/enums/bogGameNames.js';
import '../../core/helpers/updateHalfBets.js';
import 'howler';
import '../../../_commonjsHelpers-17aad09c.js';
import '../../hooks/useTranslation.js';
import '../../core/helpers/setTranslationValues.js';
import '../../core/enums/additionalInputValueChangingButtons.js';
import '../../hooks/useInputValueChangingFunctions.js';
import '../../core/helpers/checkMaxAutoCashOutValue.js';
import '../../hooks/useAmountValidation.js';
import '../../core/helpers/quickBetAmount.js';
import './betButton/halfCashOut.js';
import './betButton/betButton.js';
import './betButton/accumulatedPossibleWin.js';
import '../../core/helpers/getAmountWithCurrency.js';
import '../../core/enums/Currencies.js';

var BetSectionsAvia = observer(function (_a) {
    var sectionData = _a.sectionData, handleOpenNumPad = _a.handleOpenNumPad, isDoubleSectionsOpen = _a.isDoubleSectionsOpen;
    var openBetSection = betDataStore.openBetSection, removeBetSection = betDataStore.removeBetSection, setAutoCashOutOdd = betDataStore.setAutoCashOutOdd, setIsAutoCashOutOpen = betDataStore.setIsAutoCashOutOpen, setBetAmount = betDataStore.setBetAmount;
    var _b = doBetStore, _c = sectionData.index, _d = _b.doBetSectionsData[_c], isBetAccepted = _d.isBetAccepted, isNextRoundBet = _d.isNextRoundBet, freeBetId = _d.freeBetId, freeBetMinOdd = _b.freeBetMinOdd;
    var freeBetAmount = sectionData.freeBetAmount, isAutoCashOut = sectionData.isAutoCashOut, freeBetCurrentOdd = sectionData.freeBetCurrentOdd;
    var activeFreeBet = freeBetStore.activeFreeBet;
    var limits = gameConfigStore.limits;
    useEffect(function () {
        if ((!isBetAccepted && activeFreeBet.id) || freeBetId) {
            var currentBetAmount = activeFreeBet.amount || freeBetAmount;
            var currentOdd = freeBetCurrentOdd || activeFreeBet.minOdd || freeBetMinOdd;
            if (currentBetAmount) {
                setBetAmount(currentBetAmount, sectionData.index);
            }
            setAutoCashOutOdd(currentOdd, sectionData.index);
        }
        else if (!isBetAccepted && !activeFreeBet.id && limits.minBet && !freeBetId) {
            setBetAmount(limits.defaultBetAmount || limits.minBet, sectionData.index);
            setAutoCashOutOdd(gameStore.defaultMinOdd, sectionData.index);
            if (isAutoCashOut) {
                setIsAutoCashOutOpen(!isAutoCashOut, sectionData.index);
            }
        }
    }, [activeFreeBet.id, freeBetId]);
    return (sectionData.isOpen && (React.createElement("div", { className: 'aviabet-bet-section-item' },
        sectionData.isAutoBetOpen && React.createElement(AutoBetPopUp, { key: sectionData.index, sectionIndex: sectionData.index }),
        React.createElement("div", { className: 'aviabet-bet-section-item-inner' },
            React.createElement("div", { className: "aviabet-bet-section-holder  ".concat(sectionData.isAutoBet || isBetAccepted || isNextRoundBet ? 'autoBet-disabled' : '', " ") },
                React.createElement("div", { className: 'aviabet-bet-section-left' },
                    React.createElement(BetAmount, { sectionIndex: sectionData.index, handleOpenNumPad: handleOpenNumPad }),
                    React.createElement(QuickBetAmountButtons, { sectionIndex: sectionData.index }),
                    React.createElement(AutoCashOut, { sectionIndex: sectionData.index, handleOpenNumPad: handleOpenNumPad })),
                React.createElement("div", { className: 'aviabet-bet-section-right' },
                    React.createElement(DoBetBtnSection, { sectionIndex: sectionData.index }),
                    React.createElement(AutoBet, { sectionIndex: sectionData.index }))),
            sectionData.index !== 1 ? (React.createElement("div", { className: 'add-aviabet-section-block', onClick: function () { return openBetSection(sectionData.index); }, style: { display: isDoubleSectionsOpen ? 'none' : '' } },
                React.createElement("div", { className: 'add-aviabet-section-block-inner' },
                    React.createElement("i", { className: 'ui-lib-avi-plus' })))) : (React.createElement("div", { className: 'close-bet-section-icon', onClick: function () { return removeBetSection(sectionData.index); } },
                React.createElement("i", { className: 'ui-lib-avi-minus' })))))));
});

export { BetSectionsAvia };
